import * as React from "react";
import { CandyTooltip } from "react-ui";
import { PropsWithChildren } from "react";

import { AbsoluteResolvedModelPath, convertToAbsoluteModelPath } from "../../../Common/ModelPath/ModelPath";

import { DebugInfoEnabledContext } from "./DebugInfoEnabledContext";
import { createHocDisplayName, extractNameFromComponent, GetProps, nullElement } from "./TypingUtils";
import { DomElementHack } from "./Commons/DOM/DomElementHack";
import { ControlDebugTooltipContent } from "./Internals/DebugTools/ControlDebugTooltipContent/ControlDebugTooltipContent";

export interface BindedControlProps {
    bindingPath?: string | AbsoluteResolvedModelPath;
}

export function withControlDebugInfo<C extends React.ComponentType<PropsWithChildren<GetProps<C>>>>(
    Component: C
): React.ComponentType<JSX.LibraryManagedAttributes<C, PropsWithChildren<GetProps<C>>> & BindedControlProps> {
    if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") {
        function ControlDebugInfo(
            props: JSX.LibraryManagedAttributes<C, PropsWithChildren<GetProps<C>>> & BindedControlProps
        ): JSX.Element {
            const componentElement = React.useRef<DomElementHack>(nullElement);
            const showDebugInfo = React.useContext(DebugInfoEnabledContext);
            const bindingPath = props.bindingPath;

            return showDebugInfo && bindingPath != undefined ? (
                <>
                    <CandyTooltip
                        trigger="hover"
                        useWrapper={false}
                        allowedPositions={["bottom left", "left top", "left bottom", "right bottom", "right top"]}
                        pos={"bottom left"}
                        closeButton={false}
                        render={() => (
                            <ControlDebugTooltipContent
                                componentName={extractNameFromComponent(Component) ?? "Unknown"}
                                controlProps={props as Record<string, unknown>}
                                bindingPath={convertToAbsoluteModelPath(bindingPath)}
                            />
                        )}>
                        <DomElementHack ref={componentElement}>
                            <Component {...props} />
                        </DomElementHack>
                    </CandyTooltip>
                </>
            ) : (
                <Component {...props} />
            );
        }
        ControlDebugInfo.displayName = createHocDisplayName(Component, "ControlDebugInfo");
        return ControlDebugInfo;
    } else {
        // @ts-expect-error Тут вот так, компонент не меняется, вроде
        return Component;
    }
}
